import { call, put } from 'redux-saga/effects';
import { Actions, ActionTypes } from '../actions';
import { uploadCSV } from './network';

// All data sagas to add to middleware.
export default [
    [ActionTypes.DO_UPLOAD_CSV, doUploadCSV]
];

function * doUploadCSV ({ payload }) {
    yield put(Actions.doingUploadCsv());

    const response = yield call(uploadCSV, payload);

    if (!response.successful) {
        yield put(Actions.showMessage({type: "error", code: response.code}));
    } else {
        yield put(Actions.doneUploadCsv(response.data));
    }
}